import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { FichaSSoAvanceModel } from 'src/app/models/ficha-sso/FichaSSoAvanceModel';
import { FichaSsoModel } from 'src/app/models/ficha-sso/FichaSsoModel';
import { IFichaSsoModel } from 'src/app/models/interfaces/ficha-sso/IFichaSsoModel';
import { IFilterFichaSsoModel } from 'src/app/models/interfaces/ficha-sso/IFilterFichaSsoModel';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { eTypeResult } from 'src/app/models/common/enumModel';

@Injectable({
  providedIn: 'root'
})
export class FichaSsoService {
  private configUrl = [environment.apiGatewayUrl, 'ficha-sso'].join('/');
  constructor(private http: HttpClient,
    private datepipe: DatePipe) { }

  getList(
    model: IFilterFichaSsoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<FichaSsoModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if (model.anio > 0) {
      queryParams.push(`anio=${model.anio}`);
    }

    if (model.meses.length > 0) {
      queryParams.push(`meses=${model.meses.join(',')}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.idEstado > 0){
      queryParams.push(`idEstado=${model.idEstado}`);
    }

    if(model.idCompania > 0){
      queryParams.push(`companias=${model.idCompania}`);
    }

    return this.http.get<SearchResultModel<FichaSsoModel[]>>(
      this.configUrl + '?'+ queryParams.join('&')
    );
  }

  exportList(
    model: IFilterFichaSsoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<HttpResponse<Blob>> {
    let queryParams: string[] = new Array<string>();
    
    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if (model.anio > 0) {
      queryParams.push(`anio=${model.anio}`);
    }

    if (model.meses.length > 0) {
      queryParams.push(`meses=${model.meses.join(',')}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.idEstado > 0){
      queryParams.push(`idEstado=${model.idEstado}`);
    }

    if(model.idCompania > 0){
      queryParams.push(`companias=${model.idCompania}`);
    }

    return this.http.get(`${this.configUrl}/exportar?${queryParams.join('&')}`, { observe: 'response', responseType: 'blob'});
  }

  getAvance(
    model: IFilterFichaSsoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<FichaSSoAvanceModel> {
    let queryParams: string[] = new Array<string>();
    
    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if (model.anio > 0) {
      queryParams.push(`anio=${model.anio}`);
    }

    if (model.meses.length > 0) {
      queryParams.push(`meses=${model.meses.join(',')}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.idEstado > 0){
      queryParams.push(`idEstado=${model.idEstado}`);
    }

    if(model.idCompania > 0){
      queryParams.push(`companias=${model.idCompania}`);
    }

    return this.http.get<FichaSSoAvanceModel>(
      this.configUrl + '/avance?'+ queryParams.join('&')
    );
  }

  getListContratista(
    model: IFilterFichaSsoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<FichaSsoModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if (model.anio > 0) {
      queryParams.push(`anio=${model.anio}`);
    }

    if (model.meses.length > 0) {
      queryParams.push(`meses=${model.meses.join(',')}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.idEstado > 0){
      queryParams.push(`idEstado=${model.idEstado}`);
    }

    if(model.idCompania > 0){
      queryParams.push(`companias=${model.idCompania}`);
    }

    return this.http.get<SearchResultModel<FichaSsoModel[]>>(
      this.configUrl + '/contratista?'+ queryParams.join('&')
    );
  }

  getListContratistaToExport(
    model: IFilterFichaSsoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<HttpResponse<Blob>> {
    let queryParams: string[] = new Array<string>();
    
    
    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if (model.anio > 0) {
      queryParams.push(`anio=${model.anio}`);
    }

    if (model.meses.length > 0) {
      queryParams.push(`meses=${model.meses.join(',')}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.idEstado > 0){
      queryParams.push(`idEstado=${model.idEstado}`);
    }

    if(model.idCompania > 0){
      queryParams.push(`companias=${model.idCompania}`);
    }

    return this.http.get(this.configUrl + '/contratista/exportar?'+ queryParams.join('&'), { observe: 'response', responseType: 'blob'});
  }
  
  update(model: IFichaSsoModel): Observable<ActionResultModel> {
    return this.http.put<ActionResultModel>(
      `${this.configUrl}/${model.idFichaSso}`,
      model
    )
  }

  
  upload(formData: FormData, id: number, anio: string){ //model: ISolicitudCompletarModel
    return this.http.post(`${this.configUrl}/${id}/upload/${anio}`, formData, {reportProgress: true, observe: 'events'});
  }

  downloadDocumento(id: number): Observable<Blob> {
    return this.http.get(`${this.configUrl}/${id}/documento/download`, { responseType: 'blob' });
  }

  errorHandler(error: HttpErrorResponse) {
    //return Observable.throw(error.message || "server error.");
    
      let errorMsg: ActionResultModel = new ActionResultModel();
      errorMsg.type=eTypeResult.ERROR;
      if (error.error instanceof ErrorEvent) {
          errorMsg.message = `Error: ${error.error.message}`;
      } else {
          errorMsg.message = "Ocurrio un error";
      }

      return errorMsg;
}
}
